import type { OktaAuth } from '@okta/okta-auth-js';

import { getCurrentAccount, updateUser } from 'api/generated/users/users';
import { failAccountSetup, isAccountRefusalError } from 'api/interceptors';

import {
  closeOktaSession,
  ensureMarketviewRole,
  getOktaUserId,
} from 'helpers/okta-session';

const INVALID_REDIRECT_PATHS = ['/implicit', '/login'];

export const restoreOriginalUri = async (
  authClient: OktaAuth,
  originalUri?: string
): Promise<void> => {
  void closeOktaSession(authClient);

  const isValidRedirect =
    originalUri &&
    !INVALID_REDIRECT_PATHS.some((path) => originalUri.includes(path));
  const redirectTarget = isValidRedirect ? originalUri : '/';
  const date = new Date();

  const oktaId = getOktaUserId();

  if (!oktaId) {
    window.location.replace(redirectTarget);

    return;
  }

  try {
    const userData = await getCurrentAccount(oktaId);

    if (!(await ensureMarketviewRole(authClient))) {
      await failAccountSetup(authClient);

      return;
    }

    const oktaUserId = userData.oktaUserId;

    if (!oktaUserId) {
      window.location.replace(redirectTarget);

      return;
    }

    updateUser(oktaUserId, {
      ...userData,
      lastLogin: date.toISOString(),
    }).finally(() => {
      window.location.replace(redirectTarget);
    });
  } catch (error) {
    if (isAccountRefusalError(error)) return;

    throw error;
  }
};
